import { NgForOf } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { FormatType } from '../../../stringformat/stringformat.component';

@Component({
  selector: 'app-address-field-format',
  templateUrl: './address-field-format.component.html',
  imports: [
    MatSelect,
    MatOption,
    FormsModule,
    NgForOf
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldFormatComponent implements AfterViewInit, OnDestroy {
  @Input() fieldControl: FormControl;

  formatTypes = [];
  format = FormatType;
  formatSelected = null;
  private fieldControlSubscription: Subscription;

  constructor() {
  }

  ngAfterViewInit(): void {
    if (!this.fieldControl.value) {
      this.fieldControl.setValue(AddressFieldFormatComponent.getDefaultValue());
    } else {
      this.formatSelected = this.fieldControl.value;
    }
    this.formatTypes = Object.keys(FormatType);
    this.fieldControlSubscription = this.fieldControl.valueChanges.subscribe(value => {
      if (!value) {
        this.formatSelected = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.fieldControlSubscription?.unsubscribe();
  }

  private static getDefaultValue(): any {
    return '';
  }

  changeValue(value: string): void {
    this.fieldControl.setValue(value);
    this.formatSelected = value;
  }
}
